export const createGetContentDnaRequest = ({ disableLoading = false } = {}) => {
  return {
    url: "/content_dna",
    method: "GET",
    disableLoading,
  };
};

export const createRegenerateContentDnaRequest = (linkedinProfileUrl) => {
  return {
    url: "/content_dna/regenerate",
    method: "POST",
    data: linkedinProfileUrl === undefined ? {} : { linkedin_profile_url: linkedinProfileUrl },
  };
};

export const createImportContentDnaRequest = (content) => {
  return {
    url: "/content_dna/import",
    method: "POST",
    data: { content },
  };
};

export const createUpdateContentDnaRequest = (data) => {
  return {
    url: "/content_dna",
    method: "PUT",
    data,
  };
};

export const createConfirmContentDnaRequest = () => {
  return {
    url: "/content_dna/confirm",
    method: "POST",
  };
};

// --- Content DNA Interview (SUP-296) ---

export const createGetInterviewQuestionsRequest = () => {
  return {
    url: "/content_dna/interview/questions",
    method: "GET",
  };
};

export const createContentDnaInterviewRequest = ({ mode } = {}) => {
  return {
    url: "/content_dna/interview",
    method: "POST",
    data: { mode },
    // Cold-start UI renders its own welcome bubble + typing indicator while
    // this resolves; we don't want the global page-level spinner stacking on
    // top of that.
    disableLoading: true,
  };
};

export const createGetContentDnaInterviewRequest = (interviewId) => {
  return {
    url: `/content_dna/interview/${interviewId}`,
    method: "GET",
    disableLoading: true,
  };
};

export const createInterviewAgentTurnRequest = (interviewId, { userMessage } = {}) => {
  return {
    url: `/content_dna/interview/${interviewId}/agent_turn`,
    method: "POST",
    data: { user_message: userMessage },
    // useAgentLoop owns its own loading state and the chat shell shows a
    // typing indicator during in-flight calls.
    disableLoading: true,
  };
};

export const createGetInterviewSignedUrlRequest = (interviewId) => {
  return {
    url: `/content_dna/interview/${interviewId}/signed_url`,
    method: "GET",
  };
};

// Bulk-submit the writing samples collected in the dedicated up-front step
// (both seeded and cold-start paths) before the agent conversation begins.
export const createSubmitInterviewSamplesRequest = (interviewId, { samples } = {}) => {
  return {
    url: `/content_dna/interview/${interviewId}/samples`,
    method: "PUT",
    data: { samples },
    // The samples step owns its own submitting state; no global page spinner.
    disableLoading: true,
  };
};

export const createSubmitInterviewAnswersRequest = (
  interviewId,
  { answers, writingSamples } = {}
) => {
  return {
    url: `/content_dna/interview/${interviewId}/answers`,
    method: "PUT",
    data: {
      answers,
      writing_samples: writingSamples,
    },
  };
};
